// src/components/views/LoginView.js
import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { BookOpen, Mail } from 'lucide-react';

// 경로 주의: 상위 폴더로 두 번 올라가야 services에 접근 가능
import { fireAuth as auth } from '../../services/firebase';

// 상수도 같이 가져옵니다 (나중에 constants 파일로 뺄 수도 있지만 일단 여기에 둡니다)
const COMMON_PASSWORD = "law_quiz_common_pass_2024!";

export default function LoginView({ setView }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if(!email.trim()) return;
    setIsLoggingIn(true);
    try {
      await signInWithEmailAndPassword(auth, email, COMMON_PASSWORD);
    } catch (err) {
      console.error(err);
      if (err.code === 'auth/invalid-credential' || err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setError('가입되지 않은 이메일입니다. 아래 [회원가입 하러가기]를 눌러주세요.');
      } else {
        setError('로그인 중 오류가 발생했습니다.');
      }
      setIsLoggingIn(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 min-h-[60vh]">
      <div className="bg-slate-800 border border-slate-700 p-8 rounded-2xl shadow-2xl w-full max-w-md relative">
        <div className="text-center mb-8">
          <div className="bg-indigo-900/50 p-4 rounded-full inline-block mb-4 animate-bounce">
            <BookOpen className="h-10 w-10 text-indigo-400" />
          </div>
          <h2 className="text-2xl font-bold text-white">도승하평가사 암기연습</h2>
          <p className="text-slate-400 text-sm mt-2">합격을 위한 필수 조문 암기</p>
        </div>
        
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-xs font-bold text-slate-400 mb-1 ml-1">이메일</label>
            <div className="flex items-center bg-slate-900 border border-slate-600 rounded-lg px-3 focus-within:ring-2 focus-within:ring-indigo-500 transition">
              <Mail className="w-5 h-5 text-slate-500 mr-3" />
              <input 
                type="email" 
                required 
                className="w-full bg-transparent py-3 text-white outline-none placeholder-slate-600" 
                placeholder="email@example.com" 
                value={email} 
                onChange={e => setEmail(e.target.value)} 
              />
            </div>
          </div>
          
          {error && <p className="text-red-400 text-xs text-center font-bold bg-red-900/20 p-2 rounded">{error}</p>}

          <button 
            type="submit" 
            disabled={isLoggingIn}
            className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-3.5 rounded-xl shadow-lg transition transform active:scale-95 disabled:opacity-50 flex justify-center items-center"
          >
             {isLoggingIn ? '확인 중...' : '시작하기'}
          </button>
        </form>

        <div className="mt-8 text-center border-t border-slate-700 pt-4">
          <p className="text-slate-500 text-sm mb-2">아직 회원이 아니신가요?</p>
          <button onClick={() => setView('signup')} className="text-indigo-400 hover:text-indigo-300 font-bold underline text-sm">
            회원가입 하러가기
          </button>
        </div>
      </div>
    </div>
  );
}